<template>
  <v-combobox
    v-bind="$attrs"
    v-model="localValue"
    :items="items"
    :search-input.sync="search"
    :loading="loading"
    :disabled="isDisabled"
    :readonly="readonly"
    :clearable="clearable"
    :append-icon="`${readonly ? '' : '$vuetify.icons.dropdown'}`"
    hide-selected
    multiple
    small-chips
    hide-details
    :deletable-chips="!readonly"
    :return-object="returnObject"
  >
    <template v-slot:no-data>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            No results matching "<strong>{{ search }}</strong>".
            Press <kbd>enter</kbd> to create a new one.
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <template v-slot:selection="{ item, parent, selected }">
      <v-chip
        color="success"
        text-color="white"
        :selected="selected"
        small
      >
        <span :class="{'pr-2': !readonly}">
          <template v-if="typeof item === 'object' && returnObject">
            {{ item.name }}
          </template>
          <template v-else>
            {{ item }}
          </template>
        </span>
        <v-icon
          small
          v-if="!readonly"
          @click="parent.selectItem(item)"
        >close
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
export default {
  name: 'multipleInputs',
  props: {
    value: Array,
    model: {},
    disabled: {
      type: Boolean,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    items: Array,
    returnObject: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      search: '',
      loading: false,
      localItems: [],
    };
  },
  async mounted() {
    if (!this.model) {
      this.localItems = this.items;
    } else {
      await this.init();
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    localListeners() {
      return {
        ...this.$listeners,
        focus: event => this.$emit('focus', event.target.value),
        blur: event => this.$emit('blur', event.target.value),
      };
    },
    isDisabled() {
      return this.loading || this.disabled;
    },
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        await this.model.$fetch();
        this.items = this.model.all();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
